import { Injectable, Component } from '@angular/core';
import { RequestsService } from './requests.service';
import { AppConfig } from '../config';
// import { options } from '../forms/custom-builder/options';
// import { async } from '@angular/core/testing';

@Injectable({
  providedIn: 'root'
})
export class ParserService {

  url = AppConfig.url_backend;

  data:any = {}

  constructor(private request: RequestsService) { }


  async angularToHs(angularjson: any, form_name: string, submittext: string, email_notify:string) {
    let components = angularjson.components;

    let hs_json = this.setmetaJsonHS(form_name, submittext, email_notify);
    let field_groups = hs_json.formFieldGroups;
    let list_dependientes = []; 
    
    //console.log("TODOA LA INFO ", hs_json );
    //console.log("GRUPOS De formulario ", field_groups);
    for (let component of components) {

      if((component.type != "columns") && (component.type != "container") && (component.type != "button")  && (component.type != "htmlelement")){
        try {
          let field_maped = await this.mapFieldProperties(component);
          let field = {
            fields: [field_maped],
            default: true,
            isSmartGroup: false
          }
          field_groups.push(field);
        } catch (error) {
          console.log(error); 
        }
      }

      /**
       * ============================INICIO DE LAS COLUMNAS=================================
       */
      if(component.type === "columns"){
    //    console.log('Es un componente de columna', component);
        component.columns.map(async(element)=>{
          //console.log('Esto tiene mas elementos en una sola columna', element.components);
          for(let comp in element.components){
          //  console.log('componente individual',element.components[comp]);
            try {
              let field_maped = await this.mapFieldProperties(element.components[comp]);
              let field = {
                fields: [field_maped],
                default: true,
                isSmartGroup: false
              }
              field_groups.push(field);
            } catch (error) {
              console.log(error); 
            }
          }

        }); 
        
        /**
         * =================================FIN DE LAS COLUMNAS=============================
         */

      }else if(component.type == "container"){
        console.log('Es un componente de tipo container', component);  
            
        if(component.hasOwnProperty("conditional")){
          //console.log("Es dependiente");
          for (const comp of component.components) {
            if(comp.hasOwnProperty('columns')){
              for (const iterator of comp.columns) {
                for (const i of iterator.components) {
                  try {
                    let field_maped = await this.mapFieldProperties(i);
                    let field = {
                      filters: [
                        {
                          operator: "EQ",
                          strValue: "",
                          boolValue: false,
                          numberValue: component.conditional.eq ? component.conditional.eq : 0,
                          strValues: [
                            String(component.conditional.eq)
                          ],
                          numberValues: []
                        }
                      ],
                      dependentFormField: [field_maped],
                      default: true,
                      isSmartGroup: false
                    }

                    //console.log('Este es el dependiente',field);
                    for (const campo of field_groups) {
                      for (const c of campo.fields) {
                      /*  console.log('Este es el iterado', c);
                        console.log('c.name: ', c.name);
                        console.log('comp.key ', component.conditional.when);*/
                        if(c.name === component.conditional.when){
                          console.log('Encontrado en columnas ...');
                          //list_dependientes.push(field)
                          //c.dependentFieldFilters = list_dependientes;
                          let aux = [];
                          aux.push(field);
                          if(c.dependentFieldFilters == undefined){
                            c.dependentFieldFilters = aux;
                          }else{
                            c.dependentFieldFilters.push(field);  
                            //console.log('Esto inserto ', c.dependentFieldFilters );
                          }
                        }
                      }

                    }
                  } catch (error) {
                    console.log(error);
                  }
                }   
              }
            }else{
              try {
                let field_maped = await this.mapFieldProperties(comp);
                let field = {
                  filters: [
                    {
                      operator: "EQ",
                      strValue: "",
                      boolValue: false,
                      numberValue: component.conditional.eq ? component.conditional.eq : 0,
                      strValues: [
                        component.conditional.eq
                      ],
                      numberValues: []
                    }
                  ],
                  dependentFormField: [field_maped],
                  default: true,
                  isSmartGroup: false
                }
                /*console.log('Este es el dependiente',field);
                console.log('GRUPOS DE FIELD ', field_groups);*/
                for (const campo of field_groups) {
                  for (const i of campo.fields) {

                  /*  console.log('Este es el iterado', i);
                    console.log('i.name: ', i.name);
                    console.log('comp.key ', comp.key);
                    console.log("Componente ", component.conditional.when );*/
                    if(i.name === component.conditional.when){
                      //console.log('Encontrado...');
                      //let sizedependientes = lista_keys.length;
                      //list_dependientes.push(field);
                      //i.dependentFieldFilters = list_dependientes;
                      let aux = [];
                      aux.push(field);
                      if(i.dependentFieldFilters == undefined){
                        i.dependentFieldFilters = aux;
                      }else{
                        i.dependentFieldFilters.push(field);  
                        console.log('Esto inserto ', i.dependentFieldFilters );
                      }
                      
                    }
                  }
                }
                //field_groups.push(field);
              } catch (error) {
                console.log(error); 
              }
            }
          }
 
        }

        console.log('Data a enviar', field_groups);
        
        
        /*for (const comp of component.components) {
          if(comp.hasOwnProperty('columns')){
            //console.log('Tiene columnas');
            for (const iterator of comp.columns) {
              //console.log('---->',iterator);
              for (const i of iterator.components) {
                //console.log('=====>', i);
                try {
                  let field_maped = await this.mapFieldProperties(i);
                  let field = {
                    fields: [field_maped],
                    default: true,
                    isSmartGroup: false
                  }
                  field_groups.push(field);
                } catch (error) {
                  console.log(error); 
                }   
              }   
            }
          }else{
            try {
              let field_maped = await this.mapFieldProperties(comp);
              let field = {
                fields: [field_maped],
                default: true,
                isSmartGroup: false
              }
              field_groups.push(field);
            } catch (error) {
              console.log(error); 
            }
          }
        }*/
      }
    }

    return hs_json
  }

  private setmetaJsonHS(form_name: string, submittext: string, email_notify:string): any {
    let metastr: string = "";
    let metajson =
    {
      // this.url = 'https://ebiseguridad.azurewebsites.net/api/Function1?code=koBOLvsBdUA4P2oNaFalZjtGlPjBcIwvco3dX9N7F2MM7Zz89dRFKg==';
      name: form_name,
      action: "",
      method: "",
      cssClass: "hs-form stacked",
      redirect: "",
      submitText: submittext,
      followUpId: "",
      notifyRecipients: email_notify,
      leadNurturingCampaignId: "",
      formFieldGroups: []
    };

    return metajson;
  }

  

  async mapFieldProperties(component: any) {
    //Se cambio la propiedad key por la propiedad dada en el property name
    if(component.label == 'Email' || component.label == 'Correo electrónico' || component.label == "Correo"){
      component.key = 'email'
    }else{
      //component.key = component.propiedad; 
      //delete component.propiedad;
    }
    if(component.type == 'recaptcha' &&  component.eventType == 'buttonClick'){
      component.key = 'recaptcha'
    }
    if(component.type == 'recaptcha'  && component.eventType == 'formLoad'){
      component.key = 'recaptcha2'
    }

    let opciones = await this.getvalues(component);
    //console.log('opciones',opciones);
    let field = {
      name: component.key, //component.label
      label: component.label,
      type: this.getType( component, component.type),
      fieldType: this.getFieldType(component.type),
      description: component.description != undefined ? component.description : "",
      groupName: "contactinformation",
      displayOrder: 1,
      required: component.validate != undefined ? component.validate.required : false,
      selectedOptions: [],
      options: opciones,
      validation: {
        name: "",
        message: component.validate != undefined ? component.validate.customMessage: "",
        data: "",
        useDefaultBlockList: false
      },
      enabled: Boolean(JSON.parse(component.input)),
      hidden: false,
      defaultValue: this.getDefaultValue( component.defaultValue),
      isSmartField: false,
      unselectedLabel: "",
      propertyObjectType: "CONTACT",
      placeholder: component.placeholder != undefined ? component.placeholder : "",
      metaData: this.getMetadata(component.type)
    }

    //console.log('field', field);
    
    return field;
  }

  getMetadata(tipo:any){
    if(tipo== "datetime" || tipo== "date"){
    //  console.log('Es de tipo date');
      return [{
        name: "format",
        value:"DD-MM-YYYY"
      },{
        name:"separator",
        value:"/"
      }]
    }
    return []
  }

  getDefaultValue( dValue:any ){
    if( !dValue ) return '';
    if( typeof( dValue )=== 'string' && typeof( !dValue )=== 'number' ) return dValue;
    if( typeof( dValue)==='object' ) return '';
    return '';
  }

  getType(component:any, angulartype: string) {
    let type = 'string';
    switch (angulartype) {
      case 'textArea':
        break;
      case 'textfield':
        if( component.widget ){
          const con = component.widget;
          type = ( con.type === 'calendar' ) ? 'date' : "string";
        }
        break;
      case 'day':
        type = 'date';
        break;
      case 'select':
        type = 'enumeration';
        break;
      case 'radio':
        type = 'enumeration';
        break;
      case 'number':
        type = 'number';
        break;
      case 'selectboxes':
        type = 'enumeration';
        break;
      case 'file':
        break;
      case 'datetime':
        type = 'date'
        break;
      case 'currency':
        type = 'number'
      default:
        break;
    }
    return type;
  }

  getFieldType( angularftype: any) {
    let type = angularftype;
      if( angularftype === 'textfield' )return 'text';
      if( angularftype === 'selectboxes' ) return 'checkbox';
      if( angularftype === 'file' ) return 'file';
      if( angularftype === 'datetime' ) return 'date';
      if( angularftype === 'currency' ) return 'number';
      if( angularftype === 'checkbox' ) return 'booleancheckbox'
      
    return type;
  }

  async getvalues(component: any) {
    //console.log('Esto trae el component en el getValues',component);
    let values = [];
    /*if (component.values || component.data) {
      
    } else {
      return [];
    }*/

    if(component.type == 'checkbox'){}

    if (component.type == 'radio' || component.type == 'selectboxes') {
      //console.log('Es un radio o un selectboxes');
      let resp = await fetch(`${this.url}/options/${component.key}`);
      let body = await resp.json();
      component.values = body.values;
      
      for (let option of component.values) {
        let hs_option = {
          label: option.label, 
          value: option.value,
          displayOrder: -1,
          doubleData: 0.0,
          hidden: false,
          description: "",
          readOnly: false
        };
        hs_option.label = option.label;
        hs_option.value = option.value;
        values.push(hs_option);
      }

    } 
    
    if (component.type == "select") {
      //console.log('Es un tipo select');
      //component.key = component.propiedad; 
      try {
        let resp = await fetch(`${this.url}/options/${component.key}`);
        let body = await resp.json();
        component.data = body;
      } catch (error) {
        console.log(error);
        return;
      }
      
      let i = 0;
      for (let option of component.data.values) {

      //  console.log(option);
      
        let hs_option = {
          label: option.label,
          value: option.value,
          displayOrder: -1,
          doubleData: 0.0,
          hidden: false,
          description: "",
          readOnly: false
        };
        hs_option.label = option.label;
        hs_option.value = option.value;
        hs_option.displayOrder = i;
        values.push(hs_option);
        i++;
      }

    }

    return values;
  }


}

